import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiResolvePagingParams } from 'ng-jhipster';
import { Observable } from 'rxjs';
import { UserRouteAccessService } from 'src/app/core';
import { CargoGroupMySuffix, ICargoGroupMySuffix } from 'src/app/shared/model/cargo-group-my-suffix.model';
import { CargoGroupMySuffixDeletePopupComponent } from './cargo-group-my-suffix-delete-dialog.component';
import { CargoGroupMySuffixDetailComponent } from './cargo-group-my-suffix-detail.component';
import { CargoGroupMySuffixUpdateComponent } from './cargo-group-my-suffix-update.component';
import { CargoGroupMySuffixComponent } from './cargo-group-my-suffix.component';
import { CargoGroupMySuffixService } from './cargo-group-my-suffix.service';

@Injectable({ providedIn: 'root' })
export class CargoGroupMySuffixResolve implements Resolve<ICargoGroupMySuffix> {
    constructor(private service: CargoGroupMySuffixService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            if(state.url.includes('/view')){
                return this.service.view(id).map((cargoGroupView: HttpResponse<CargoGroupMySuffix>) => cargoGroupView.body)
            }
            return this.service.find(id).map((cargoGroup: HttpResponse<CargoGroupMySuffix>) => cargoGroup.body);
        }
        return Observable.of(new CargoGroupMySuffix());
    }
}

export const cargoGroupRoute: Routes = [
    {
        path: 'cargo-group',
        component: CargoGroupMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'CargoGroups'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'cargo-group/:id/view',
        component: CargoGroupMySuffixDetailComponent,
        resolve: {
            cargoGroup: CargoGroupMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'CargoGroups'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'cargo-group/new',
        component: CargoGroupMySuffixUpdateComponent,
        resolve: {
            cargoGroup: CargoGroupMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'CargoGroups'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'cargo-group/:id/edit',
        component: CargoGroupMySuffixUpdateComponent,
        resolve: {
            cargoGroup: CargoGroupMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'CargoGroups'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const cargoGroupPopupRoute: Routes = [
    {
        path: 'cargo-group/:id/delete',
        component: CargoGroupMySuffixDeletePopupComponent,
        resolve: {
            cargoGroup: CargoGroupMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'CargoGroups'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];
